import React from "react";
import { notifyError } from "./notifyError";

export class FeatureSafe extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const label = this.props.componentName || "Component";
    console.error(`FEATURE ERROR (${label}):`, error, errorInfo);
    if (!this.props.silent) {
      notifyError(error?.message || `${label} failed`);
    }
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback !== undefined) {
        return this.props.fallback;
      }
      return null;
    }

    return this.props.children;
  }
}
